import { render, staticRenderFns } from "./CoursewareStructuralElementComments.vue?vue&type=template&id=1f801016&"
import script from "./CoursewareStructuralElementComments.vue?vue&type=script&lang=js&"
export * from "./CoursewareStructuralElementComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports